import { createAction } from 'redux-act'

export const set = createAction('SET_FILTER')
export const clearFilter = createAction('CLEAR_FILTER')
